<script>
    import {cartItemsStore, decrementItemInCart, incrementItemInCart} from "../cart/cart-store.js";
    import {onDestroy} from "svelte";
    import OrderButton from "../components/OrderButton.svelte";
    import { t } from '../core/i18n/language-store';

    export let record;
    export let price;
    export let publishConfig;

    let showAll;
    let cartIsEmpty = false;
    let cartHasRecord = false;

    const storeSubscriptions = [
        cartItemsStore.subscribe(items => {
            cartIsEmpty = (items || []).length === 0;
            cartHasRecord = (items || []).filter(x => x.id === record.id).length > 0;
        })
    ];

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>
    .cart-preview-container {
        padding: 1rem 0;
    }
    hr {
        border: none;
        border-top: 1px solid #ffffff;
        opacity: .2;
        margin: 1rem 0 .75rem 0;
    }
    .selector {
        text-align: right;
        color: var(--secondary-font-color);
    }
    .selector--active {
        color: var(--accent-color);
    }
    strong {
        font-family: Roboto Condensed, sans-serif;
        text-transform: uppercase;
        font-weight: 400;
    }
    .price {
        font-family: PT Mono, sans-serif;
        color: var(--accent-color);
    }
    .added-item {
        color: var(--main-font-color);
        background: var(--bg-color);
        margin-top: .5rem;
        padding: 0.375rem 0;
        border-radius: 0;
    }
    .mods {
        color: var(--secondary-font-color);
        font-family: Roboto Condensed, sans-serif;
    }
</style>

{#if (!cartIsEmpty)}
    <div class="cart-preview-container">
        <div class="flex-between">
            <strong>{$t('cart.title')}:</strong>
            <span class="selector fs-85">
                <span class="pointer" class:selector--active={!showAll} on:click={() => showAll = false}>{ record.name || $t('cart.unnamed') }</span> | <span class="pointer" class:selector--active={showAll} on:click={() => showAll = true}>{$t('cart.all')}</span>
            </span>
        </div>
        <hr>
        <ul>
            {#if (!showAll && !cartHasRecord)}
                <li>{ record.name || $t('cart.unnamed') } {$t('cart.notInCart')}</li>
            {/if}
            {#each $cartItemsStore as cartItem}
                {#if (showAll || record.id === cartItem.id)}
                    <li class="added-item scale-in-animation">
                        <div class="flex-between ai-center fs-90 lh-1">
                            <div class="flex-fill">

                                <div>
                                    <span class="wrap-anywhere">{ cartItem.name || 'Без названия' }</span>

                                    {#if (cartItem.weight)}
                                        <span class="wrap-anywhere">{ cartItem.weight }</span>
                                    {/if}

                                    <br>

                                    {#if (cartItem.modsDescription?.length > 0)}
                                    <span class="mods wrap-anywhere">
                                        ({ cartItem?.modsDescription })
                                    </span>
                                    {/if}
                                </div>

                                <div class="price">{ cartItem.price || '-' }&nbsp;{ publishConfig?.currency }</div>
                            </div>
                            <div class="flex ai-center">
                                <OrderButton record="{{_orderedItems:cartItem.count}}"
                                             on:add={() => incrementItemInCart({id: cartItem.id}, price, cartItem.priceIndex, cartItem.mods)}
                                             on:remove={() => decrementItemInCart({id: cartItem.id}, price, cartItem.priceIndex, cartItem.mods)}
                                ></OrderButton>
                            </div>
                        </div>
                    </li>
                {/if}
            {/each}
        </ul>
    </div>
{/if}
